import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { contains2el4s70rdq4ld as contains } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  _ULong___init__impl__c78o9k1vasxel72m2l4 as _ULong___init__impl__c78o9k,
  _ULong___get_data__impl__fggpzbbo8lz7f8fnfy as _ULong___get_data__impl__fggpzb,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import {
  shiftRightUnsigned1ga7wnvbv2qur as shiftRightUnsigned,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _ShortId___init__impl__tlblaa(asString) {
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(_ShortId___get_asString__impl__omz5t8(asString).length === 8)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!contains('ABCDEFGHJKLMNPQRSTUVWXYZ23456789', charCodeAt(_ShortId___get_asString__impl__omz5t8(asString), 0))) {
    var message_0 = 'Failed requirement.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!contains('ABCDEFGHJKLMNPQRSTUVWXYZ23456789', charCodeAt(_ShortId___get_asString__impl__omz5t8(asString), 1))) {
    var message_1 = 'Failed requirement.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_1));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!contains('ABCDEFGHJKLMNPQRSTUVWXYZ23456789', charCodeAt(_ShortId___get_asString__impl__omz5t8(asString), 2))) {
    var message_2 = 'Failed requirement.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_2));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(charCodeAt(_ShortId___get_asString__impl__omz5t8(asString), 3) === _Char___init__impl__6a9atx(45))) {
    var message_3 = 'Failed requirement.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_3));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!contains('ABCDEFGHJKLMNPQRSTUVWXYZ23456789', charCodeAt(_ShortId___get_asString__impl__omz5t8(asString), 4))) {
    var message_4 = 'Failed requirement.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_4));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!contains('ABCDEFGHJKLMNPQRSTUVWXYZ23456789', charCodeAt(_ShortId___get_asString__impl__omz5t8(asString), 5))) {
    var message_5 = 'Failed requirement.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_5));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!contains('ABCDEFGHJKLMNPQRSTUVWXYZ23456789', charCodeAt(_ShortId___get_asString__impl__omz5t8(asString), 6))) {
    var message_6 = 'Failed requirement.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_6));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!contains('ABCDEFGHJKLMNPQRSTUVWXYZ23456789', charCodeAt(_ShortId___get_asString__impl__omz5t8(asString), 7))) {
    var message_7 = 'Failed requirement.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_7));
  }
  return asString;
}
function _ShortId___get_asString__impl__omz5t8($this) {
  return $this;
}
function toShortId(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  // Inline function 'kotlin.uuid.Uuid.toULongs' call
  // Inline function 'kotlin.toULong' call
  var this_1 = _this__u8e3s4.mostSignificantBits_1;
  var tmp0 = _ULong___init__impl__c78o9k(this_1);
  // Inline function 'kotlin.toULong' call
  var this_2 = _this__u8e3s4.leastSignificantBits_1;
  var leastSignificantBits = _ULong___init__impl__c78o9k(this_2);
  // Inline function 'kotlin.ULong.shr' call
  var tmp0_0 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(tmp0), 5));
  // Inline function 'kotlin.ULong.and' call
  var other = _ULong___init__impl__c78o9k(31n);
  // Inline function 'kotlin.ULong.toInt' call
  var this_3 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_0) & _ULong___get_data__impl__fggpzb(other));
  var tmp$ret$9 = convertToInt(_ULong___get_data__impl__fggpzb(this_3));
  this_0.append_58al37_k$(charCodeAt('ABCDEFGHJKLMNPQRSTUVWXYZ23456789', tmp$ret$9));
  // Inline function 'kotlin.ULong.shr' call
  var tmp0_1 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(tmp0), 10));
  // Inline function 'kotlin.ULong.and' call
  var other_0 = _ULong___init__impl__c78o9k(31n);
  // Inline function 'kotlin.ULong.toInt' call
  var this_4 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_1) & _ULong___get_data__impl__fggpzb(other_0));
  var tmp$ret$12 = convertToInt(_ULong___get_data__impl__fggpzb(this_4));
  this_0.append_58al37_k$(charCodeAt('ABCDEFGHJKLMNPQRSTUVWXYZ23456789', tmp$ret$12));
  // Inline function 'kotlin.ULong.shr' call
  var tmp0_2 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(tmp0), 15));
  // Inline function 'kotlin.ULong.and' call
  var other_1 = _ULong___init__impl__c78o9k(31n);
  // Inline function 'kotlin.ULong.toInt' call
  var this_5 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_2) & _ULong___get_data__impl__fggpzb(other_1));
  var tmp$ret$15 = convertToInt(_ULong___get_data__impl__fggpzb(this_5));
  this_0.append_58al37_k$(charCodeAt('ABCDEFGHJKLMNPQRSTUVWXYZ23456789', tmp$ret$15));
  this_0.append_58al37_k$(_Char___init__impl__6a9atx(45));
  // Inline function 'kotlin.ULong.shr' call
  var tmp0_3 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(leastSignificantBits), 5));
  // Inline function 'kotlin.ULong.and' call
  var other_2 = _ULong___init__impl__c78o9k(31n);
  // Inline function 'kotlin.ULong.toInt' call
  var this_6 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_3) & _ULong___get_data__impl__fggpzb(other_2));
  var tmp$ret$18 = convertToInt(_ULong___get_data__impl__fggpzb(this_6));
  this_0.append_58al37_k$(charCodeAt('ABCDEFGHJKLMNPQRSTUVWXYZ23456789', tmp$ret$18));
  // Inline function 'kotlin.ULong.shr' call
  var tmp0_4 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(leastSignificantBits), 10));
  // Inline function 'kotlin.ULong.and' call
  var other_3 = _ULong___init__impl__c78o9k(31n);
  // Inline function 'kotlin.ULong.toInt' call
  var this_7 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_4) & _ULong___get_data__impl__fggpzb(other_3));
  var tmp$ret$21 = convertToInt(_ULong___get_data__impl__fggpzb(this_7));
  this_0.append_58al37_k$(charCodeAt('ABCDEFGHJKLMNPQRSTUVWXYZ23456789', tmp$ret$21));
  // Inline function 'kotlin.ULong.shr' call
  var tmp0_5 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(leastSignificantBits), 15));
  // Inline function 'kotlin.ULong.and' call
  var other_4 = _ULong___init__impl__c78o9k(31n);
  // Inline function 'kotlin.ULong.toInt' call
  var this_8 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_5) & _ULong___get_data__impl__fggpzb(other_4));
  var tmp$ret$24 = convertToInt(_ULong___get_data__impl__fggpzb(this_8));
  this_0.append_58al37_k$(charCodeAt('ABCDEFGHJKLMNPQRSTUVWXYZ23456789', tmp$ret$24));
  // Inline function 'kotlin.ULong.shr' call
  var tmp0_6 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(leastSignificantBits), 20));
  // Inline function 'kotlin.ULong.and' call
  var other_5 = _ULong___init__impl__c78o9k(31n);
  // Inline function 'kotlin.ULong.toInt' call
  var this_9 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_6) & _ULong___get_data__impl__fggpzb(other_5));
  var tmp$ret$27 = convertToInt(_ULong___get_data__impl__fggpzb(this_9));
  this_0.append_58al37_k$(charCodeAt('ABCDEFGHJKLMNPQRSTUVWXYZ23456789', tmp$ret$27));
  var tmp$ret$0 = this_0.toString();
  return _ShortId___init__impl__tlblaa(tmp$ret$0);
}
//region block: exports
export {
  _ShortId___get_asString__impl__omz5t8 as _ShortId___get_asString__impl__omz5t82x1ggxl12av4g,
  toShortId as toShortId2um7whkmaulbx,
};
//endregion

//# sourceMappingURL=humanId.mjs.map
